<label
  class="absolute text-lg text-gray-600 -translate-x-1 -translate-y-6 scale-75 z-10 origin-[0] bg-transparent start-1 font-bold max-w-[100%]"
  [for]="for()"
>
  <ng-content></ng-content>

  {{ label() }}

  @if (required()) {
    <span class="text-red-600" aria-hidden="true">*</span>
    <span class="sr-only">Required</span>
  }
</label>
